import { memo, useEffect, useState } from 'react';
import Table from '../../components/Table/Table';
import DateInput from '../../components/DateInput';
import Filter from '../../components/Filter/Filter';
import { FirstFilterLine, SecondFilterLine } from '../../components/Filter/Filter.styles';
import TextField from '../../components/TextField';
import Wrapper from '../../components/Wrapper/Wrapper';
import Button from '../../components/Button/Button';
import { useForm } from 'react-hook-form';
import { ImSearch } from 'react-icons/im';
import SelectOptions from '../../components/SelectOptions';
import { useDispatch, useSelector } from 'react-redux';
import { transfersFetchAction } from '../../store/fetchActions/transfersActions';
import formatCPF from '../../utils/functions/formatCPF';
import StatusContainer from '../../components/StatusContainer/StatusContainer';
import * as dayjs from 'dayjs';
import formatMoney from '../../utils/functions/formatMoneyBRL';
import InformationTransfer from '../../components/Transfer/InformationTransfer.';
import Modal from '../../components/Modal/Modal';
import transformObjectUppercase from '../../utils/functions/transformObjectUppercase';
import useCallFilter from '../../utils/hooks/useCallFilter';
import { getPaymentWayAndTransactionTypes } from '../../store/fetchActions/reportsActions';
import * as S from './Transferencias.styles';
import { useTheme } from 'styled-components';
import moment from 'moment';
import { pagesOptions } from '../../utils/constant';
import Loading from '../../components/Loading';

function Transferencias() {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [filterData, setFilterData] = useState('');
  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  const [ModalInfoData, setModalInfoData] = useState({});
  const [filter, setFilter] = useState({
    SEARCH: '',
    DATA_INICIAL: '',
    DATA_FINAL: '',
    AGENCIA: '',
    CONTA: '',
    TIPO: 'Interna',
    LIMIT: 10,
    PAGE: 1,
  });
  const [dateInicial, setDateInicial] = useState(null);
  const [dateFinal, setDateFinal] = useState(moment().format('YYYY-MM-DD'));

  const { handleSubmit, control } = useForm({});

  useEffect(() => {
    dispatch(getPaymentWayAndTransactionTypes());
  }, []);

  const { transfersData, paginationTransfers, loadingTransfers, errorTransfers, messageTransfers } = useSelector(
    (state) => state.transfers,
  );
  const { status_transacao } = useSelector((state) => state?.reports);

  useCallFilter(filterData, setFilter, transfersFetchAction, 0, 0);

  const filterTable = (data) => {
    data.DATA_INICIAL = dateInicial;
    data.DATA_FINAL = dateFinal;
    data.TIPO = 'Interna';
    setFilterData(data);
  };

  useEffect(() => {
    dispatch(transfersFetchAction(transformObjectUppercase(filter)));
  }, [filter.PAGE]);

  const arrayStatus = status_transacao?.map((status) => {
    return { ID: status.ID, NOME: status.NOMECLATURA };
  });

  arrayStatus.unshift({ ID: 0, NOME: 'Todos' });

  const header = [
    {
      id: 'data e hora',
      name: 'DATA/HORA',
      align: 'left',
    },
    { id: 'cpf/cnpj', name: 'CPF/CNPJ', align: 'left' },
    { id: 'nome', name: 'NOME', align: 'left' },
    { id: 'valor', name: 'VALOR', align: 'right' },
    { id: 'status', name: 'STATUS', align: 'center' },
  ];

  const body = transfersData?.map((transfer) => {
    return {
      data: [
        {
          info: dayjs(transfer.DATA_INSERT).format('DD/MM/YYYY HH:mm:ss') || '-----',
          align: 'left',
        },
        {
          info: formatCPF(transfer.CPFCNPJ),
          align: 'left',
        },
        {
          info: transfer.NOME,
          align: 'left',
          width: '25rem',
        },
        {
          info:
            transfer.TIPOTRANSFERENCIA === 'CRÉDITO' ? (
              <S.ColorValue mycolor={theme.colors.darklimeGreen} myfont={'800'}>
                {'R$ + ' + formatMoney(transfer.VALOR)}
              </S.ColorValue>
            ) : (
              <S.ColorValue mycolor={theme.colors.vividRed_2} myfont={'800'}>
                {'R$ - ' + formatMoney(transfer.VALOR)}
              </S.ColorValue>
            ),
          align: 'right',
        },
        {
          info: transfer.STATUSTRANSACAO ? (
            <StatusContainer code={transfer.STATUSTRANSACAO} description={transfer.STATUS_DESCRICAO}></StatusContainer>
          ) : (
            '-----'
          ),
          align: 'center',
        },
      ],
      onClick: () => inspectUser(transfer),
    };
  });

  const inspectUser = (data) => {
    setModalInfoData(data);
    setIsModalInfoOpen(true);
  };

  return (
    <Wrapper title="Transferência Interna">
      <div>
        <Filter>
          <form onSubmit={handleSubmit(filterTable)}>
            <FirstFilterLine>
              <TextField label="Nome ou CPF/CNPJ" name={'SEARCH'} width={'30.042vw'} control={control} />
              <SelectOptions
                label={'Status'}
                width={'9.528vw'}
                name={'STATUS'}
                control={control}
                options={arrayStatus}
                initialValue={'0'}
              />
              <DateInput
                label="Data Inicial"
                name={'DATA_INICIAL'}
                control={control}
                value={dateInicial}
                onChange={(newValue) =>
                  newValue?.$d ? setDateInicial(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateInicial(null)
                }
              />
              <DateInput
                label="Data Final"
                name={'DATA_FINAL'}
                control={control}
                value={dateFinal}
                onChange={(newValue) =>
                  newValue?.$d ? setDateFinal(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateFinal(null)
                }
              />

              <Button
                backgroundcolor={theme.colors.buttonSearch}
                width="17.153vw"
                margin={'0 1.389vw 0 0'}
                hoverbgcolor={theme.colors.buttonSearchHover}
                hovercolor={theme.colors.buttonSearchHoverText}
                mycolor={theme.colors.buttonSearchText}
                type="submit"
              >
                <ImSearch className="default-svg" size={'1.181vw'} />
                <span>Buscar</span>
              </Button>
            </FirstFilterLine>
            <SecondFilterLine>
              <h5>Resultados por página</h5>
              <SelectOptions control={control} options={pagesOptions} name={'LIMIT'} initialValue={10} />
              <h5>Total de resultados: {paginationTransfers?.totalResult}</h5>
            </SecondFilterLine>
          </form>
        </Filter>
        {loadingTransfers ? (
          <Loading />
        ) : (
          <Table
            loading={loadingTransfers}
            error={errorTransfers}
            hasPagination={true}
            filter={filter}
            pagination={paginationTransfers}
            setFilter={setFilter}
            errorMessage={messageTransfers}
            filterTable={filterTable}
            header={header}
            body={body}
            limit={filter.LIMIT}
          />
        )}

        {isModalInfoOpen && (
          <Modal
            open={isModalInfoOpen}
            close={() => setIsModalInfoOpen(false)}
            title="Dados da Transferência"
            width={'45.889vw'}
          >
            <InformationTransfer data={ModalInfoData} />
          </Modal>
        )}
      </div>
    </Wrapper>
  );
}

export default memo(Transferencias);
